import React from 'react';
import { useLocation } from 'react-router-dom';
import { ComponentDocument } from '../../components/signer/ComponentDocument';
import { ComponentAsideShare } from '../../components/signer/ComponentAsideShare';
import { ComponentAlerts } from '../../components/signer/ComponentAlerts';

export const SharedDocument = ({ fileName }) => {
    const location = useLocation();
    const { alertType, alertMessageKey } = location.state || {};

    return (
        <main className="main-content main-grid">
            <div>
                {alertType && alertMessageKey && (
                    <ComponentAlerts alertType={alertType} alertMessageKey={alertMessageKey} />
                )}
                <ComponentDocument fileName={fileName} />
            </div>
            <div>
                <ComponentAsideShare fileName={fileName} />
            </div>
        </main>
    );
};
